import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdDiscount } from 'react-icons/md';

import { useGetDiscountCodes } from 'legacy/events/hooks';

import SettingsOption, { OptionType } from '../SettingsOption';

interface DiscountCodesSettingsProps {
  eventId: string;
  navigateToDiscountCodes: () => void;
}

const DiscountCodesSettings: React.FC<DiscountCodesSettingsProps> = ({
  eventId,
  navigateToDiscountCodes
}) => {
  const { t } = useTranslation(['events']);
  const { data: discountCodesResult } = useGetDiscountCodes(eventId, {
    enabled: true
  });

  return (
    <SettingsOption
      icon={<MdDiscount size={20} />}
      title={t('events:settings.discountCodes.title')}
      actionLabel={t('events:settings.discountCodes.actionLabel')}
      onClick={navigateToDiscountCodes}
      value={
        discountCodesResult?.discountCodes.length
          ? t('events:settings.discountCodes.totalCount', {
              count: discountCodesResult?.discountCodes.length
            })
          : ''
      }
      type={OptionType.Button}
    />
  );
};

export default DiscountCodesSettings;
